export class ErrorUrls {
  public static readonly BASE = 'error';
  public static readonly ERROR_404 = '404';
  public static readonly ERROR_403 = '403';
}

export class LoginUrls {
  public static readonly BASE = 'login';
  public static readonly EMAIL_VERIFICATION = 'email-verification';
  public static readonly EMAIL_CHANGE_VERIFICATION = 'email-change-verification';
  public static readonly SSO = 'sso';
  public static readonly ACCESS_RESTRICTED = 'access-restricted';
}

export class PasswordUrls {
  public static readonly FORGOT_PASSWORD = 'forgot-password';
  public static readonly EXPIRED_PASSWORD = 'expired-password';

  // Remove this
  public static readonly FORGOT_PASSWORD_RESET = 'forgot-password-reset';
  public static readonly RESET_PASSWORD = 'reset-password';
  public static readonly CREATE_NEW_PASSWORD = 'create-new-password';
}

export class DashboardUrls {
  public static readonly BASE = 'dashboard';
}
